import {
  SlMenu
} from "./chunk.Q6CVTR7F.js";

// src/components/menu/menu.ts
var menu_default = SlMenu;
SlMenu.define("sl-menu");

export {
  menu_default
};
